export enum Brand {
    feed = 'feed',
    femcare = 'femcare',
    tc = 'tc',
    tcw = 'tcw',
    tork = 'tork',
    tpw = 'tpw',
    baby = 'baby'
}
